import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchJson } from '../apiBase';

function useToken() {
  return useMemo(() => {
    try {
      const sp = new URLSearchParams(window.location.search);
      return sp.get('token') || '';
    } catch {
      return '';
    }
  }, []);
}

export default function ValuesEvaluationMagic() {
  const navigate = useNavigate();
  const token = useToken();
  const [error, setError] = useState('');

  useEffect(() => {
    const run = async () => {
      if (!token) {
        setError('Bağlantı eksik veya hatalı.');
        return;
      }
      try {
        const res = await fetchJson(`/parent/values/magic?token=${encodeURIComponent(token)}`);
        if (!res.ok) throw new Error();
        const data = await res.json();
        const themeId = data.theme_id;
        const formId = data.form_id;
        if (!themeId || !formId) throw new Error();
        navigate(`/value-evaluation/${encodeURIComponent(themeId)}/${encodeURIComponent(formId)}?token=${encodeURIComponent(token)}`, { replace: true });
      } catch {
        setError('Form yönlendirilemedi. Lütfen bağlantıyı yeniden açmayı deneyin.');
      }
    };
    run();
  }, [navigate, token]);

  if (error) {
    return (
      <div style={{ padding: 16, fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif' }}>
        {error}
      </div>
    );
  }

  return (
    <div style={{ padding: 16, fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif' }}>
      Yönlendiriliyor…
    </div>
  );
}
